export enum MiniViewSourceTable {
  FulfillmentGroups = "fulfillment-groups",
  PurchaseOrders = "purchase-orders",
  ReplenishmentRequests = "replenishment-requests",
  ReplenishmentReport = "replenishment-report",
}
